import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog")
      .then(({ data }) => setPosts(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6] grain" data-testid="blog-list-page">
      <Navbar />
      <section className="pt-40 pb-20">
        <div className="container-prose">
          <p className="text-overline mb-6">Baza wiedzy</p>
          <h1 className="font-display text-5xl md:text-7xl text-[#2B2B2B] leading-[0.95] mb-12 max-w-3xl">
            Artykuły, które otwierają drzwi.
          </h1>

          {loading && <p className="text-[#5C6670]">Ładowanie…</p>}

          <div className="grid md:grid-cols-2 gap-10 mt-8">
            {posts.map((p, i) => (
              <Link
                to={`/blog/${p.slug}`} key={p.id}
                data-testid={`blog-list-card-${i}`}
                className="group block bg-white rounded-2xl overflow-hidden border border-[#E5E0D8] hover:-translate-y-1 transition-transform duration-500"
              >
                {p.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                )}
                <div className="p-10">
                  <p className="text-overline mb-4">{p.category}</p>
                  <h2 className="font-display text-3xl text-[#2B2B2B] leading-tight mb-4 group-hover:text-[#8A9A86] transition-colors">{p.title}</h2>
                  <p className="text-[#5C6670] font-light leading-relaxed">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>

          {!loading && posts.length === 0 && (
            <p className="text-[#5C6670]">Brak artykułów.</p>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
